import app from 'flarum/forum/app';
app.initializers.add('val-ui-suppress-generic-network-alert', () => {
  const messages = ['Il semble y avoir un problème avec votre connexion. Veuillez vérifier votre réseau et réessayer.', 'It looks like there was a problem with your connection. Please check your network connection and try again.'];
  const clean = () => {
    document.querySelectorAll('.App-notices .Alert, .AlertManager .Alert').forEach(alert => {
      const text = (alert.textContent || '').replace(/\s+/g, ' ').trim();
      if (messages.some(message => text.includes(message))) {
        alert.remove();
      }
    });
  };
  clean();
  const observer = new MutationObserver(clean);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
});